<template>
  <div id="summary" class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="confirm(false)"><span class="blind">close</span></button>
      <h1 class="notranslate">{{isExpresscheckin ? locale.summary_title_expresscheckin : locale.summary_title}}</h1>
      <h2 class="room notranslate">{{room}}</h2>
      <div class="submitAt notranslate">{{submitAt}}</div>
      <!-- <div v-if="disabled">
        <p class="noData">{{locale.request_nodata}}<br>{{locale.ask_front}}</p>
        <button type="button" class="btn btnFull btnWhite" @click.stop="confirm(false)">{{locale.cancel}}</button>
      </div> -->
      <div v-if="!isExpresscheckin || !isCheckout" class="requiredSubject">{{summary.info.subject[lang]}}</div>
      <div>
        <div v-if="hasOptions || dateTime" class="optionInfo">
          <div class="list"
            v-for="order in summaryData"
            :key="order.id"
            :class="{hasSubOption: order.hasSubOption, isSubOption: order.isSubOption}">
            <div v-if="order.type === 'checkbox'" class="row" :style="{marginLeft: `${order.isSubOption && (order.optionDepth - 1) * 10}px`}">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value">
                <div class="valueOption"
                  v-for="(option, index) in displayValue(order)"
                  :key="index">
                  {{option}}
                  <span v-if="option.quantity" class="colorGrey">({{option.quantity}})</span>
                </div>
              </div>
            </div>
            <div v-else-if="order.type === 'signaturepad'" class="row">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value notranslate">
                <img :src="order.value" alt="" />
              </div>
            </div>
            <div v-else-if="order.type === 'cert'" class="row">
              <span class="labe">{{order.label[lang]}}</span>
              <div class="value notranslate">
                <div>{{locale.name}}: {{order.value.name}}</div>
                <div>{{locale.telephone}}: {{order.value.phone}}</div>
                <div>{{locale.birthdate}}: {{order.value.birthDate}}</div>
              </div>
            </div>
            <div v-else-if="order.type === 'uploadImage'" class="row">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value">
                <div class="valueOption"
                  v-for="(option, index) in order.value"
                  :key="index">
                  <span v-if="option.previewType === 'filename'">🖺 {{option.name}}</span>
                  <img v-else :src="option.path" alt="">
                </div>
              </div>
            </div>
            <div v-else class="row" :style="{marginLeft: `${order.isSubOption && (order.optionDepth - 1) * 10}px`}">
              <span class="label">{{order.label[lang]}}</span>
              <div class="value"
                :class="{notranslate: order.type === 'rate'}">
                {{displayValue(order)}}
              </div>
            </div>
          </div>
          <div class="setDatetime row notranslate"
            v-if="dateTime">
            <span class="label">{{dateTime.value.datetimeOnly === 'date'
              ? locale.date
              : dateTime.value.datetimeOnly === 'time'
                ? locale.time
                : locale.datetime}}</span>
            <span class="value">{{requestTime}}</span>
          </div>
        </div>
        <div v-if="!summary.price.info.noPrice && (summary.price.info.quantity || summary.price.info.total >= 0)" class="priceInfo toCapitalize">
          <!-- 단가 -->
          <div v-if="summary.price.info.price" class="row priceDpBoard notranslate">
            <span class="label toCapitalize">{{locale.summary_unitprice}}</span>
            <span class="value price">{{priceFormat(priceByQuantity.price)}}</span>
          </div>
          <!-- //단가 -->
          <!-- 옵션금액+수량 -->
          <div v-if="priceOption.length" class="priceDpBoard">
            <div class="row"
              v-for="(info, index) in priceOption"
              :key="index"
              :class="{hide: info.invisible}">
              <div class="label notranslate toCapitalize">
                <span class="optionStkr">{{locale.option_price}}</span> {{info.label}}
                <span v-if="info.price" class="priceStkr">{{priceFormat(info.price)}}</span>
                <span v-if="info.quantity" class="colorGrey"> ({{info.quantity}})</span>
              </div>
              <div class="value price notranslate">{{getOptionPrice(info)}}</div>
            </div>
          </div>
          <!-- //옵션금액+수량 -->
          <!-- 전체수량 -->
          <div v-if="summary.price.info.quantity" class="row notranslate">
            <span class="labe toCapitalizel">{{locale.quantity}}</span>
            <span class="value price">{{priceByQuantity.quantity}}</span>
          </div>
          <!-- //전체수량 -->
          <!-- 고객식별타입 -->
          <div v-if="summary.guestTypePrice && isGuestDiscount" class="guestType row priceDpBoard">
            <div class="label toCapitalize">
              {{summary.guestTypePrice.name[lang]}}<span v-if="summary.guestTypePrice.discountPrice"> ({{summary.guestTypePrice.priceDiscount}})</span>
            </div>
            <div class="value price notranslate">{{priceFormat(summary.guestTypePrice.discountPrice) || summary.guestTypePrice.priceDiscount}}</div>
          </div>
          <!-- //고객식별타입 -->
          <!-- dutyfree -->
           <div v-if="summary.price.info.isDutyFree" class="priceDpBoard notranslate">
            <div class="row">
              <span class="label toCapitalize"></span>
              <span class="value price">{{ summary.guestTypePrice ? summary.guestTypePrice.name[lang] : 'Duty Free' }}</span>
            </div>
          </div>
          <!-- //dutyfree -->
          <!-- tax -->
          <div v-if="summary.price.info.tax" class="tax priceDpBoard notranslate">
            <div class="row">
              <span class="label toCapitalize">{{locale.subtotal}}</span>
              <span class="value price">{{priceFormat(summary.price.info.subtotal)}}</span>
            </div>
            <div class="row">
              <span class="label toCapitalize">{{locale.tax}}({{summary.price.info.taxLabel}})</span>
              <span class="value price">{{priceFormat(summary.price.info.tax)}}</span>
            </div>
          </div>
          <!-- //tax -->
          <!-- 적용된 쿠폰 -->
          <div v-if="useCoupon && useCoupon.length > 0" class="applyCoupon notranslate">
            <div v-for="(coupon, index) in useCoupon" :key="index" class="row" :class="{interSection: couponIntersection(coupon.cid)}">
              <div class="label toCapitalize">
                <span class="optionStkr">{{locale.coupon}}</span>
                {{coupon.payload.text1[lang] || coupon.payload.text2[lang] || coupon.title}}
                <span v-if="coupon.payload.discountType === 'rate'" class="priceDpBoard">
                  (-{{coupon.payload.discountValue}}%)
                </span>
                <span v-if="couponIntersection(coupon.cid)" class="priceDpBoard">
                  ({{getCouponValue(coupon.payload)}} * {{couponIntersection(coupon.cid).qty}})
                </span>
              </div>
              <div class="value price priceDpBoard">
                <span v-if="couponIntersection(coupon.cid)">
                  {{getCouponValue(coupon.payload, couponIntersection(coupon.cid).qty)}}
                </span>
                <span v-else>
                  {{getCouponValue(coupon.payload)}}
                </span>
              </div>
            </div>
          </div>
          <!-- 적용된 쿠폰 -->
          <!-- 총합계 -->
          <div class="calculate row notranslate priceDpBoard">
            <div class="label toCapitalize">{{locale.total}}</div>
            <div class="value price">
              <!-- 쿠폰할인
              <div v-if="summary.useCoupon && summary.useCoupon.couponPrice">
                <span v-if="summary.useCoupon.couponPrice.normalPrice" class="normalPrice">{{priceFormat(summary.useCoupon.couponPrice.normalPrice)}}</span>
                {{priceFormat(summary.useCoupon.couponPrice.price)}}
              </div>
              //쿠폰할인 -->
              <!-- 게스트타입할인
              <div v-else-if="summary.guestTypePrice">
                <span v-if="summary.guestTypePrice.normalPrice" class="normalPrice">{{priceFormat(summary.guestTypePrice.normalPrice)}}</span>
                {{priceFormat(summary.guestTypePrice.price)}}
              </div>
              //게스트타입할인 -->
              <!-- 할인없음
              <div v-else>
                {{priceFormat(summary.price.info.total)}}
              </div>
              할인없음 -->
              <div>{{priceFormat(summary.price.info.total)}}</div>
            </div>
          </div>
          <!-- //총합계 -->
        </div>
        <!-- 사용가능 쿠폰 -->
        <div v-if="usableCoupon && usableCoupon.length > 0" class="couponMessageBox">
          <p class="usableCouponMessage right">
            <span>{{useCoupon && useCoupon.length ? locale.message_page_applied_coupon : locale.message_page_usable_coupon}}</span>
          </p>
          <button type="button" class="btn btnWhite sizeS" @click="openMyCoupon">{{locale.view_coupon}}</button>
        </div>
        <!-- //사용가능 쿠폰 -->
        <div v-if="disabledSubmit" v-html="disabledMessage()" class="disabledMessage"></div>
        <div v-if="isCart" class="btns notranslate">
          <button
            type="button"
            class="btn toCapitalize"
            :disabled="useCoupon && useCoupon.length"
            @click.stop="confirm('cart')">{{locale.cart}}</button>
          <button
            type="button"
            class="btn btnWhite toCapitalize"
            @click.stop="confirm('request')">{{locale.btn_request}}</button>
        </div>
        <div v-else class="btns notranslate">
          <button type="button" class="btn btnWhite toCapitalize" @click.stop="confirm(false)">{{locale.cancel}}</button>
          <button
            type="button"
            class="btn toCapitalize"
            @click.stop="confirm('request')">{{locale.confirm}}</button>
        </div>
        <div v-if="useCoupon && useCoupon.length" class="colorRed mt10">{{locale.message_disabled_cart_coupon}}</div>
      </div>
    </div>
    <MyCoupon
      v-if="couponLayer"
      :lang="lang"
      :locale="locale"
      :pageId="pageId"
      :hasChecked="useCoupon && useCoupon.map(x => x.iid)"
      @updateUsableCoupon="updateUsableCoupon"
      @apply="applyMyCoupon"
      @close="closeMyCoupon" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import MyCoupon from '@/components/Util/MyCoupon'

export default {
  name: 'Summary',
  props: [
    'lang',
    'locale',
    'summary',
    'isCart',
    'isExpresscheckin',
    'isCheckout',
    'disabledSubmit',
    'usableCoupon',
    'pageId'
  ],
  components: {
    MyCoupon
  },
  computed: {
    ...mapGetters({
      getPriceInfo: 'page/getPriceInfo',
      getPriceOption: 'page/getPriceOption'
    }),
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    room () {
      return this.$store.state.authentication.space
    },
    disabled () {
      return this.summaryData.length === 0
    },
    hasOptions () {
      return this.summaryData.filter(x => x.type && x.type !== 'quantity' && x.type !== 'datetime' && x.value !== null).length
    },
    submitAt: {
      get () {
        const submitAt = DateTime.fromISO(this.summary.submitAt || moment().toISOString(), { zone: this.timezone })
        return submitAt.toFormat(this.format)
      },
      set (sa) {
        // console.log(sa)
      }
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    },
    summaryData () {
      const filter = /^(quantity|datetime)$/
      const summary = this.summary.content.filter(x => !filter.test(x.type) && x.value)
      return summary
    },
    dateTime () {
      return this.summary.content.find(x => x.type === 'datetime') || null
    },
    requestTime: {
      get () {
        const settime = this.dateTime ? DateTime.fromISO(this.dateTime.value.settime, { zone: this.timezone }) : null
        const requestTime = settime
          ? this.dateTime.value.type === 'asap'
            ? this.locale.datetime_asap
            : this.dateTime.value.datetimeOnly === 'date'
              ? settime.toFormat(this.dateFormat)
              : this.dateTime.value.datetimeOnly === 'time'
                ? settime.toFormat('HH:mm')
                : settime.toFormat(this.format)
          : null
        return requestTime
      },
      set (rt) {
        // console.log(rt)
      }
    },
    priceOption () {
      const lang = this.lang
      let option = []
      this.summaryData.forEach(function (x) {
        if (x.value) {
          if (x.type === 'checkbox') {
            option = option.concat(x.value.filter(o => o.price && `${o.price}`.length).map(function (oo) {
              return {
                label: oo.label[lang],
                price: oo.price,
                ...oo.quantity && {
                  quantity: oo.quantity
                },
                ...oo.invisible && {
                  invisible: oo.invisible
                }
              }
            }))
          } else if (x.value.price) {
            option = option.concat({
              label: x.value.label[lang],
              price: x.value.price,
              ...x.value.quantity && {
                quantity: x.value.quantity
              },
              ...x.value.invisible && {
                invisible: x.value.invisible
              }
            })
          }
        }
      })
      return option
    },
    priceByQuantity () {
      const quantity = Number(this.getPriceInfo.quantity)
      const price = Number(this.getPriceInfo.price)
      return {
        price: price,
        quantity: quantity
      }
    },
    isGuestDiscount () {
      return this.summary.guestTypePrice && this.summary.guestTypePrice.normalPrice !== this.summary.guestTypePrice.total
    },
    useCoupon () {
      return this.summary && this.summary.useCoupon && this.summary.useCoupon.useCoupon
    }
  },
  mounted () {
    const lang = this.lang
    let option = []
    for (let i = 0; i < this.summaryData.length; i++) {
      const x = this.summaryData[i]
      if (x.value) {
        if (x.type === 'checkbox') {
          option = option.concat(x.value.filter(o => o.price && `${o.price}`.length).map(function (oo) {
            return {
              label: oo.label[lang],
              price: oo.price,
              ...oo.quantity && {
                quantity: oo.quantity
              }
            }
          }))
        } else if (x.value.price) {
          option = option.concat({
            label: x.value.label[lang],
            price: x.value.price,
            ...x.value.quantity && {
              quantity: x.value.quantity
            }
          })
        }
      }
    }
  },
  data () {
    return {
      datetime: moment().toISOString(),
      datetimeStyle: {
        width: '100%',
        padding: '0',
        fontSize: '0.85em',
        opacity: '0.5',
        border: 'none',
        background: 'none'
      },
      optionDatetimeStyle: {
        width: '100%',
        padding: '0',
        border: 'none',
        background: 'none',
        verticalAlign: 'unset'
      },
      couponLayer: false
    }
  },
  methods: {
    updateUsableCoupon (couponList) {
      this.$emit('updateUsableCoupon', couponList)
    },
    applyMyCoupon (ids) {
      const coupon = ids && ids.length > 0 ? this.usableCoupon.filter(x => ids.includes(x.iid)) : null
      // this.useCoupon = coupon
      this.closeMyCoupon()
      this.$emit('applyCoupon', coupon)
    },
    openMyCoupon () {
      this.couponLayer = true
    },
    closeMyCoupon () {
      this.couponLayer = false
    },
    getOptionPrice (option) {
      const price = option.quantity ? option.price * option.quantity : option.price
      return this.priceFormat(price)
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    displayValue (order) {
      const lang = this.lang
      let value = order.value
      switch (order.type) {
        case 'rate':
          value = `${value.value} / ${value.max}`
          break
        case 'radio':
          value = value.hasInput ? value.value : value.label[lang] + (value.quantity ? ` (${value.quantity})` : '')
          break
        case 'checkbox':
          value = value.map(x => {
            const label = x.label[lang]
            const quantity = x.quantity ? ` (${x.quantity})` : ''
            return x.hasInput ? x.value : label + quantity
          })
          break
        case 'select':
          value = value.hasInput ? value.value : value.label[lang]
          break
        case 'calendar':
          value = DateTime.fromISO(value).toFormat(this.dateFormat)
          break
      }
      return value
    },
    getCouponValue (coupon, qty) {
      let result = ''
      function discountRate (total, rate) { // 할인율 적용된 금액
        const totalPrice = total && parseFloat(total) > 0
        return totalPrice ? parseFloat(total) * parseFloat(rate) / 100 : null
      }
      if (coupon && coupon.discount) {
        const discountType = coupon.discountType
        const value = coupon.discountValue
        const total = this.summary.useCoupon.couponPrice && this.summary.useCoupon.couponPrice.normalPrice
        switch (discountType) {
          case 'price':
            result = this.priceFormat(value * (qty ? parseInt(qty) : 1))
            break
          case 'rate':
            result = discountRate(total, value)
              ? `${this.priceFormat(discountRate(total, value))}` // ${value}%
              : ''
            break
        }
        result = `-${result}`
      }
      return result
    },
    couponIntersection (cid) {
      const coupon = this.useCoupon.filter(x => x.cid === cid && x.payload.allowedQty)
      return coupon && coupon.length ? {
        qty: coupon.length,
        ...coupon[0].payload.discount && coupon[0].payload.discountValue && {
          discountValue: parseInt(coupon[0].payload.discountValue) * coupon.length
        }
      } : null
    },
    disabledMessage (reason) {
      let message = ''
      switch (this.disabledSubmit) {
        // 결제가 불가능합니다.
        case ('paymentAble'):
          message = `${this.locale.message_disabled_paymentable_1}<br>${this.locale.message_disabled_paymentable_2}`
          break
        // 체크아웃 서비스를 진행할 수 없습니다.
        case ('checkOutAble'):
          message = `${this.locale.message_disabled_checkoutable_1}<br>${this.locale.alert_checkout_front}`
      }
      if (reason === 'hasCoupon') {
        message = '쿠폰 적용시 장바구니에 담을 수 없습니다.<br>바로 주문해 주세요.'
      }
      return message
    },
    confirm (e, confirm) {
      this.$emit('confirm', e, confirm)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  font-size: 14px;
  .inner {
    align-items: initial !important;
    justify-content: initial !important;
  }
  .isSubOption {
    .row {
      position: relative;
      padding-left: 12px;
      &:before {
        content: "\203A ";
        position: absolute;
        top: 0;
        left: 0;
        margin-top: 0.35em;
        font-size: 1.4em;
        font-family: sans-serif;
        line-height: 1;
        color: $color-lgrey;
      }
    }
  }
  .row {
    display: flex;
    padding: 0.3em 0;
    .label {
      width: 100px;
      margin-bottom: 0;
      padding-right: 0.3em;
    }
    .value {
      flex: 1;
      margin-left: auto;
    }
  }
  .priceInfo .row {
    .label {
      width: auto;
      margin-right: auto;
      text-align: initial;
    }
    .value {
      padding-left: 1.2em;
      white-space: nowrap;
    }
    &.byQuantity {
      .item {
        margin-right: auto;
      }
      .item:last-of-type {
        margin-left: auto;
        margin-right: 0;
      }
      .innerLabel {
        margin-right: 0.5em;
      }
    }
  }
}
.noData {
  padding-top: 3em;
  padding-bottom: 6em;
  text-align: center;
  font-size: 1.4em;
}
.price {
  text-align: right;
}
.normalPrice {
  margin-right: 10px;
  font-weight: normal;
  font-size: 0.85em;
  text-decoration: line-through;
  color: $color-grey;
}
.room {
  margin-top: 0.5em;
  margin-bottom: 2px;
  padding-bottom: 0.2em;
  text-align: center;
  font-size: 1.6em;
  font-weight: 700;
  border-bottom: 4px solid $color-dark;
}
.submitAt {
  margin-bottom: 1.2em;
  padding-top: 0.2em;
  font-size: 0.85em;
  color: $color-grey;
  border-top: 1px solid $color-dark;
  input {
    width: 100%;
    padding: 0;
    border: none;
    background: none;
  }
}
.requiredSubject {
  padding: 0.3em 0 0.5em;
  font-size: 1.2em;
  font-weight: bold;
}
.optionInfo {
  text-align: initial;
  border-top: 1px solid $color-lgrey;
  .list {
    &:nth-of-type(2n) {
      background-color: rgba($color-lgrey2, 0.25);
    }
  }
  .row {
    display: block;
    padding-top: 0.75em;
    padding-bottom: 0.75em;
    .label {
      width: auto;
      font-weight: bold;
    }
  }
}
.priceInfo {
  padding-top: 1em;
  padding-bottom: 1em;
  border-top: 1px dashed $color-lgrey;
  .optionStkr {
    display: inline-block;
    padding: 2px 8px;
    font-size: 0.85em;
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
    background-color: rgba($color-lgrey2, 0.25);
  }
  .priceStkr {
    display: inline-block;
    position: relative;
    margin-left: 2px;
    padding: 2px 4px 2px 12px;
    font-size: 0.85em;
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
    background-color: rgba($color-lgrey2, 0.25);
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 3px;
      height: 3px;
      margin-top: -3px;
      margin-left: 2px;
      border-radius: 100%;
      border: 1px solid $color-lgrey2;
      background-color: $color-grey;
    }
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: -4px;
      width: 8px;
      margin-top: -1px;
      border-top: 1px solid $color-lgrey;
    }
  }
  .guestType {
    &.row {
      margin-top: 1em;
      margin-bottom: -0.2em;
      padding-top: 1em;
      padding-bottom: 0;
      border-top: 1px dashed $color-lgrey;
    }
  }
  .applyCoupon {
    .row {
      margin-top: 1em;
      margin-bottom: -0.2em;
      padding-top: 1em;
      padding-bottom: 0;
      border-top: 1px dashed $color-lgrey;
    }
    .interSection + .interSection {
      display: none;
    }
  }
  .calculate {
    font-size: 1.2em;
    font-weight: 700;
    &.row {
      margin-top: 1em;
      padding-bottom: 0;
      padding-top: 1em;
      border-top: 1px dashed $color-lgrey;
    }
  }
  .tax {
    margin-top: 1em;
    padding-top: 1em;
    border-top: 1px dashed $color-lgrey;
    .row {
      padding-top: 0;
    }
    & + .calculate {
      margin-top: 0;
      padding-top: 0;
      border-top: none;
    }
  }
}
.list + .setDatetime {
  border-top: 1px dashed $color-lgrey;
}
.couponMessageBox {
  display: flex;
  align-items: center;
  .usableCouponMessage {
    flex: 1;
    margin: 0 15px 0 0;
  }
  .btn {
    margin-left: auto;
  }
}
</style>
